module.exports = __webpack_public_path__ + "img/compress.3d7b2f08.svg";